// Asset pipeline. If you have your own images, put them in client/public/assets/
// and list them in client/public/assets/manifest.json, for example:
//   { "items/tommy_gun": "items/tommy_gun.png", "ui/logo": "ui/logo.png" }
// Anything listed replaces the built-in drawing; anything not listed falls back to it.
// No rebuild is needed: the manifest is loaded when the game starts.

let manifest: Record<string, string> = {};

export async function loadAssetManifest(): Promise<void> {
  try {
    const res = await fetch('/assets/manifest.json', { cache: 'no-cache' });
    if (res.ok) manifest = (await res.json()) as Record<string, string>;
  } catch {
    manifest = {};
  }
}

/** URL of a supplied image for `key` (e.g. "items/tommy_gun"), or null to use built-in art. */
export function assetUrl(key: string): string | null {
  const file = manifest[key];
  return file ? `/assets/${file}` : null;
}
